export default __webpack_public_path__ + "static/media/optimalRun1.765969cc.svg";